// begin slider-md-news //
// See: https://www.design-fluide.com/wp-content/demos/owl-slider/initialize-destroy-slider-resize.html
var fn_slider_md_newslaunch = function () {

    var fn_slider_md_news = function () {

        /*** Vars ***/
        var gallery = '.slider-md-news',
            slider = false

        /*** Init ***/
        var init = function () {
        manage(); // On load (1*)

        $(window).on('resize', function () { 
            // On resize (2*)
            waitForFinalEvent(function () {
            manage()
            }, 200, 'fn_slider_md_news')
        })
        }

        /*** Manage slider ***/
        var manage = function () {
            // Test breakpoint
        var isMobile = $('html').hasClass('slider-md-on')

        if (isMobile && !slider) { 
            // If mobile and slider not built yet = build
            build()
        }
        else if (!isMobile && slider) { 
            // Not mobile but slider built = destroy
            destroy()
        }
        }

        /*** Build slider ***/
        var build = function () {
        slider = $(gallery).addClass('owl-carousel'); // Add owl slider class (3*)
        slider.owlCarousel({
            // Initialize slider
            items: 1,
            slideBy: 1,
            nav: false,
            loop: false,
            dots: true,
            responsive:{
                667:{
                    items: 2
                }
            }
        })
        }

        /*** Destroy slider ***/
        var destroy = function () {
        slider.trigger('destroy.owl.carousel'); // Trigger destroy event (4*)
        slider = false // Reinit slider variable
        $(gallery).removeClass('owl-carousel'); // Remove owl slider class (3*)
        }

        /*** Public methods***/
        return {
        init: init
        }
    }()

    // PREVENT MULTIPLE CALLS
    var waitForFinalEvent = (function () {
        var timers = {}
        return function (callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId"
        }
        if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId])
        }
        timers[uniqueId] = setTimeout(callback, ms)
        }
    })()

    // DOCUMENT READY
    fn_slider_md_news.init()
    //

};